import React from "react";
import { Outlet } from "react-router-dom";

const AuthLayout = () => {
  return (
    <main className="h-screen flex items-center justify-center bg-gray-100">
      <Outlet />
    </main>
  );
};

export default AuthLayout;
